module.exports = __webpack_public_path__ + "img/ch.a0d6ede7.png";